import { forwardRef } from 'react';
import { atom, useAtom } from 'jotai';
import { USER_ID_SOURCE, CHAT_ID_SOURCE } from './const';

const userPopupIdAtom = atom<number | string | null>(null);
const userPopupSourceAtom = atom<typeof USER_ID_SOURCE | typeof CHAT_ID_SOURCE | ''>('');
const userAvatarRefAtom = atom<typeof forwardRef | undefined>(null);
const isUserModeratorAtom = atom<boolean>(false);

type AvatarRefProps = {
    avatarRef: typeof forwardRef | undefined | null;
};

interface openPopupChatProps extends AvatarRefProps {
    id: string;
    isModerator: boolean;
}

interface openPopupQnAProps extends AvatarRefProps {
    id: number;
}

interface controlUserPopupProps extends AvatarRefProps {
    id: string | number | null;
    source: typeof USER_ID_SOURCE | typeof CHAT_ID_SOURCE | '';
    isModerator?: boolean;
}

export const useUserBusinessCardAtom = () => {
    const [showId, setShowId] = useAtom(userPopupIdAtom);
    const [userPopupSource, setUserPopupSource] = useAtom(userPopupSourceAtom);
    const [avatarRef, setUserAvatarRef] = useAtom(userAvatarRefAtom);
    const [isUserModerator, setIsUserModerator] = useAtom(isUserModeratorAtom);

    const controlUserPopup = ({
        id,
        avatarRef,
        source,
        isModerator = false,
    }: controlUserPopupProps) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        setShowId(id);
        setUserPopupSource(source);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        setUserAvatarRef(avatarRef);
        setIsUserModerator(isModerator);
    };

    const openUserIdPopup = ({ id, avatarRef }: openPopupQnAProps) => {
        controlUserPopup({ id, avatarRef, source: USER_ID_SOURCE });
    };

    const openChatIdPopup = ({ id, avatarRef, isModerator }: openPopupChatProps) => {
        controlUserPopup({ id, avatarRef, source: CHAT_ID_SOURCE, isModerator });
    };

    const closeUserPopup = () => {
        controlUserPopup({ id: null, avatarRef: null, source: '', isModerator: false });
    };

    return {
        openChatIdPopup,
        openUserIdPopup,
        closeUserPopup,
        showId,
        userPopupSource,
        avatarRef,
        isUserModerator,
    };
};
